import React, { ReactElement, useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
import { reCaptcha } from 'utils/helpers/reCaptcha';
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// import { LeadFormParameters } from 'components/LeadForm/LeadForm.data';
import useWindowSize from 'utils/hooks/useWindowSize';
import styles from 'pages/membership/Membership.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Membership/components/SectionHeader'));
const SectionPackages = dynamic(() => import('sections/Membership/components/SectionPackages'));
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// const SectionForm = dynamic(() => import('sections/Membership/components/SectionForm'));
const SectionAssociation = dynamic(() => import('sections/Membership/components/SectionAssociation'));

type MembershipProps = {
  pageTitle?: string;
  formUrl?: string;
  leadSubtype?: string;
};

export default function Membership({ pageTitle, formUrl, leadSubtype }: MembershipProps) {
  const { width } = useWindowSize();
  const [isDataLayerSent, setIsDataLayerSent] = useState(false);

  useEffect(() => {
    if (width !== 0 && !isDataLayerSent) {
      // @ts-ignore
      window.dataLayer?.push({
        event: 'homepage or membership page',
        page_url: location.href,
      });
      setIsDataLayerSent(true);
    }
  }, [width, isDataLayerSent]);

  useEffect(() => {
    reCaptcha();
  }, []);

  return (
    <div className={cn('membership')}>
      <SectionHeader />
      <SectionPackages />
      {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
      {/* <SectionForm
        pageTitle={pageTitle}
        formUrl={formUrl}
        leadSubtype={leadSubtype}
      /> */}
      <SectionAssociation />
    </div>
  );
}

export const getStaticProps = async () => {
  // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
  // 'FormParameters' - parameters, passed to 'Form' component in 'SectionForm' on all Benefits pages as additional data for CRM: 
  // const FormParameters = {
  //   pageTitle: LeadFormParameters.membership.pageTitle,
  //   formUrl: LeadFormParameters.membership.formUrl,
  //   leadSubtype: LeadFormParameters.membership.leadSubtype,
  // };

  return {
    props: {
      title: 'Join DF Alliance Membership Today | DF Alliance',
      description: 'Become a DF Alliance member and gain access to an extensive network of logistics professionals, digital tools, and global shipping resources.',
      keywords: 'freight alliance membership, freight alliance membership cost, freight membership cost, membership freight forwarder, logistics membership, digital freight alliance membership',
      path: '/membership',
      // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
      // ...FormParameters,
    },
  };
};

Membership.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
